import QuestionSolution from './QuestionSolution';

export default QuestionSolution;
